//Maaz A : 06-02-2023 : BT-95890 -  Breeze - Breeze Login - For First time users - Start
import { LOGIN, OTP, USER_REGISTER, TOTP, GUEST_LOGIN, GET_DP_DETAILS_SUCCESS, GET_DP_DETAILS_FAILURE, GET_INTEROP_CONFIG_DETAILS_SUCCESS, GET_INTEROP_CONFIG_DETAILS_FAILURE } from "../actionTypes";

const initialState = {
    userRegisterResp: {},
    signup: false,
    objLoginSession: {},
    objUserDetails: {},
    isLoading: false,
    objTotpRes: {},
    objMobileOtpRes: {},
    userId: "",
    objChangePasswordRes: {},
    objMpinRes: {},
    objGuestLoginRes: {},
    objGuestLoginOtpRes: {},
    logout: {},
    bMpinEnabled: true,
    isForgotMpin: false,
    userProfile: {},
    objChangeMpinRes: {},
    objQrRes: {},
    objForgotUserIdRes: {},
    objCFT: {},
    isResetMpin: false,
    // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
    dpDetails: {},
    interopConfig: [],
    // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
    // BT-95890 -Mahesh S -  first time user login - code added for auth service down - start
    authServiceDown: false,
    otpLoading: false,
    qrExpire: false,
    // BT-95890 -Mahesh S -  first time user login - code added for auth service down - end,
    aliasId: '',
    sessionData:{}
};



const authReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case LOGIN.UPDATE_CFT: {
            return { ...state, objCFT: actions.payload };
        }
        case LOGIN.UPDATE_SIGNUP: {
            return { ...state, signup: actions.payload };
        }
        case USER_REGISTER.USER_REGISTER_SUCCESS: {
            return { ...state, userRegisterResp: actions.payload };
        }
        case USER_REGISTER.USER_REGISTER_FAILURE: {
            return { ...state, userRegisterResp: actions.payload };
        }
        case LOGIN.UPDATE_IS_LOADING: {
            return { ...state, isLoading: actions.payload };
        }
        case LOGIN.UPDATE_MPIN_ENABLED: {
            return { ...state, bMpinEnabled: actions.payload };
        }
        case LOGIN.UPDATE_FORGOT_MPIN: {
            return { ...state, isForgotMpin: actions.payload };
        }
        case LOGIN.UPDATE_RESET_MPIN: {
            return { ...state, isResetMpin: actions.payload };
        }
        // BT-95890 -Mahesh S -  first time user login - code added for auth service down - start
        case LOGIN.AUTH_SERVICE_DOWN: {
            return { ...state, authServiceDown: actions.payload };
        }
        // BT-95890 -Mahesh S -  first time user login - code added for auth service down - end
        case LOGIN.USER_LOGIN_SUCCESS: {
            return { ...state, objLoginSession: actions.payload };
        }
        case LOGIN.USER_LOGIN_FAILURE: {
            return { ...state, objLoginSession: actions.payload };
        }
        case LOGIN.USER_SESSION_SUCCESS: {
            return { ...state, sessionData: actions.payload };
        }
        case LOGIN.USER_GENERATE_QR_CODE_SUCCESS: {
            return { ...state, objQRRes: actions.payload };
        }
        case LOGIN.USER_GENERATE_QR_CODE_FAILURE: {
            return { ...state, objQRRes: actions.payload };
        }
        case LOGIN.FORGOT_USER_ID_SUCCESS: {
            return { ...state, objForgotUserIdRes: actions.payload };
        }
        case LOGIN.FORGOT_USER_ID_FAILURE: {
            return { ...state, objForgotUserIdRes: actions.payload };
        }
        case USER_REGISTER.USER_DETAILS_SUCCESS: {
            return { ...state, objUserDetails: actions.payload };
        }
        case USER_REGISTER.USER_DETAILS_FAILURE: {
            return { ...state, objUserDetails: actions.payload };
        }
        case OTP.USER_SENT_OTP_SUCCESS: {
            return { ...state, objMobileOtpRes: actions.payload };
        }
        case OTP.USER_SENT_OTP_LOADING: {
            return { ...state, otpLoading: actions.payload };
        }
        case OTP.USER_SENT_OTP_FAILURE: {
            return { ...state, objMobileOtpRes: actions.payload };
        }
        case OTP.USER_VERIFY_OTP_SUCCESS: {
            return { ...state, objMobileOtpRes: actions.payload };
        }
        case OTP.USER_VERIFY_OTP_FAILURE: {
            return { ...state, objMobileOtpRes: actions.payload };
        }
        case TOTP.USER_REGISTER_TOTP_SUCCESS: {
            return { ...state, objTotpRes: actions.payload };
        }
        case TOTP.USER_REGISTER_TOTP_FAILURE: {
            return { ...state, objTotpRes: actions.payload };
        }
        case LOGIN.UPDATE_PASSWORD_SUCCESS: {
            return { ...state, objChangePasswordRes: actions.payload };
        }
        case LOGIN.UPDATE_PASSWORD_FAILURE: {
            return { ...state, objChangePasswordRes: actions.payload };
        }
        case USER_REGISTER.USER_REGISTER_MPIN_SUCCESS: {
            return { ...state, objMpinRes: actions.payload };

        }
        case USER_REGISTER.USER_REGISTER_MPIN_FAILURE: {
            return { ...state, objMpinRes: actions.payload };
        }
        case USER_REGISTER.USER_CHANGE_MPIN_SUCCESS: {
            return { ...state, objChangeMpinRes: actions.payload };

        }
        case USER_REGISTER.USER_CHANGE_MPIN_FAILURE: {
            return { ...state, objChangeMpinRes: actions.payload };
        }

        case LOGIN.UPDATE_USER_ID: {
            return { ...state, userId: actions.payload };
        }
        case LOGIN.ALIAS_ID: {
            return { ...state, aliasId: actions.payload };
        }
        case GUEST_LOGIN.SET_GUEST_REG_DETAILS_SUCCESS: {
            return { ...state, objGuestLoginRes: actions.payload };
        }
        case GUEST_LOGIN.SET_GUEST_REG_DETAILS_FAILURE: {
            return { ...state, objGuestLoginRes: actions.payload };
        }

        case GUEST_LOGIN.VALIDATE_GUEST_OTP_SUCCESS: {
            return { ...state, objGuestLoginOtpRes: actions.payload };
        }
        case GUEST_LOGIN.VALIDATE_GUEST_OTP_FAILURE: {
            return { ...state, objGuestLoginOtpRes: actions.payload };
        }
        //Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Start
        case LOGIN.UPDATE_NEW_PASSWORD_SUCCESS: {
            return { ...state, objChangePasswordRes: actions.payload };
        }
        case LOGIN.UPDATE_NEW_PASSWORD_FAILURE: {
            return { ...state, objChangePasswordRes: actions.payload };
        }

        case OTP.USER_SENT_OTP_MPIN_SUCCESS: {
            return { ...state, objMobileOtpRes: actions.payload };
        }
        case OTP.USER_SENT_OTP_MPIN_FAILURE: {
            return { ...state, objMobileOtpRes: actions.payload };
        }

        //Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Ends


        case LOGIN.USER_LOGOUT_SUCCESS:
            return {
                ...state,
                logout: actions.payload
            };
        case LOGIN.USER_LOGOUT_FAILURE:
            return {
                ...state,
                logout: actions.payload
            };
        case LOGIN.USER_PROFILE_SUCCESS:
            return {
                ...state,
                userProfile: actions.payload
            };
        case LOGIN.USER_PROFILE_FAILURE:
            return {
                ...state,
                userProfile: actions.payload
            };
        case LOGIN.QR_EXPIRE:
            return {
                ...state,
                qrExpire: actions.payload
            };
        // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - Start
        case GET_DP_DETAILS_SUCCESS:
            return {
                ...state,
                dpDetails: actions.payload
            };
        case GET_DP_DETAILS_FAILURE:
            return {
                ...state,
                dpDetails: actions.payload
            };
        case GET_INTEROP_CONFIG_DETAILS_SUCCESS:
            return {
                ...state,
                interopConfig: actions.payload
            };
        case GET_INTEROP_CONFIG_DETAILS_FAILURE:
            return {
                ...state,
                interopConfig: actions.payload
            };

        // Ajitesh : 16/11/2023: BT-109135: Breeze eDIS implementation - End
        default:
            return state;
    }
};

export default authReducer;